
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Mahaganpati Ganpati Temple Ranjangaon" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Mahaganpati Ganpati Temple Ranjangaon" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Mahaganpati Temple, Mahaganpati Ganpati Ranjangaon, Ashtavinayak Ganpati Ranjangaon, Ranjangaon Ganpati Temple, Mahaganpati Vinayak Temple, Ashtavinayak Yatra Ranjangaon, Mahaganpati Ganesh Pune, Ranjangaon Mahaganpati Maharashtra, Ashtavinayak Pilgrimage Ranjangaon'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Mahaganpati Temple, Mahaganpati Ganpati Ranjangaon, Ashtavinayak Ganpati Ranjangaon, Ranjangaon Ganpati Temple, Mahaganpati Vinayak Temple, Ashtavinayak Yatra Ranjangaon, Mahaganpati Ganesh Pune, Ranjangaon Mahaganpati Maharashtra, Ashtavinayak Pilgrimage Ranjangaon, Mahaganpati Temple History, ranjangaon ganpati temple distance, ranjangaon ganpati temple directions, ranjangaon ganpati temple timings, ranjangaon ganpati temple prasad timings, ranjangaon ganpati temple distance from my location, Ranjangaon Ganpati' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/mahaganpati.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/mahaganpati.webp'
          },
        ],
    }
},

    components: {
    },
    data() {
        return {
            title: 'Shree Mahaganpati Ganpati Temple Ranjangaon | Ashtavinayak - श्री महागणपती रांजणगांव(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/mahaganpati"
        },
        "headline": "Shree Mahaganpati Ganpati Temple Ranjangaon - श्री महागणपती रांजणगांव(अष्टविनायक)",
        "name" : "Shree Mahaganpati Ganpati Temple Ranjangaon - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Mahaganpati Ganpati Temple Ranjangaon' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/mahaganpati.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
